import { Box, Typography, styled } from '@mui/material';

export const CardWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  background-color: white;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
  }
`;

export const ThumbnailWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  height: 163px;
  position: relative;
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
  ${({ theme }) => theme.breakpoints.only('xs')} {
    max-height: 91px;
  }
  ${({ theme }) => theme.breakpoints.only('sm')} {
    height: 162px;
    max-height: 162px;
  }
  ${({ theme }) => theme.breakpoints.only('md')} {
    width: 252.69px;
    height: 151.17px;
    min-width: 181.18px;
    align-self: center;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 252.69px;
    height: 151.17px;
    min-width: 252.69px;
    align-self: center;
  }
`;

export const EllipsisTypography = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
`;
